import type { StatusType } from '../data-table/constants';
import { StatusMap } from '../data-table/constants';
import { Badge } from './badge';

type Status = keyof (typeof StatusMap)[StatusType];

export type StatusBadgeProps = {
  type?: StatusType;
  status?: Status | undefined | null;
  className?: string;
  before?: React.ReactNode;
}

export function StatusBadge(props: StatusBadgeProps) {
  const {
    status,
    className,
    type = 'object',
    before
  } = props;

  if (status == null || status == undefined) {
    return null;
  }
  
  return (
    <Badge className={className} variant={StatusMap[type][status]?.color}>
      {before}
      {StatusMap[type][status]?.text}
    </Badge>
  );
}